import React from "react"

const achievements1 = [
  {
    title: "Advanced formwork systems for walls, columns, beams and slabs",
    description:
      //   "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      "",
    date: "",
    month: "",
    year: "",
  },
  {
    title: "Custom-engineered slab solutions for all construction phases",
    description:
      //   "Giving your home a new style every style. good design for good moments.",
      "",
    date: "",
    month: "",
    year: "",
  },
  //   {
  //     title: "We are always evolving",
  //     description: "",
  //     //   "Don’t know how to go with plan, give everything to interior design with calm.",
  //     date: "",
  //     month: "",
  //     year: "",
  //   },
  //   {
  //     title: "Wait for our suprises",
  //     description: "",
  //     //   "Every work has its professional which can perform their task with all the best standards.",
  //     date: "",
  //     month: "",
  //     year: "",
  //   },
]

const achievements2 = [
  {
    title: "Shoring and scaffolding equipment for complex structures",
    description:
      "",
    date: "",
    month: "",
    year: "",
  },

  {
    title: "Sustainable and reusable formwork components",
    description:
      "",
    //   "Interior design, a fine line with more shine a design gives you, your deam house",
    date: "",
    month: "",
    year: "",
  },
  //   {
  //     title: "Asia Creative Competition",
  //     description:
  //       "Give your consent, we design a perfect bend choose the style, we complete with our file",
  //     date: "19",
  //     month: "July",
  //     year: "2017",
  //   },
  //   {
  //     title: "Center of Gloucester",
  //     description:
  //       "Scrambled it to make a type specimen book. remaining essentially. ",
  //     date: "27",
  //     month: "May",
  //     year: "2018",
  //   },
]

const locations = [
  {
    image: require('./../../images/our-history/1.jpg'),
    title: 'About Us',
    location: 'Building Foundations for Tomorrow',
    description:
      'Askala Company for General Trading Limited stands at the forefront of construction innovation as a premier provider of specialized formwork solutions and slab systems. With our comprehensive expertise in structural engineering and building technologies, we deliver cutting-edge formwork systems that enable the creation of complex concrete structures with precision, efficiency, and uncompromised safety. Our solutions cater to major construction projects across residential, commercial, and infrastructure developments.',
  },
]

var bgimg1 = require("./../../images/background/bg-map.png")
var bgimg2 = require("./../../images/background/cross-line2.png")

class Achievements1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full p-t80 p-b80 sx-bg-secondry bg-no-repeat bg-bottom-center mobile-page-padding"
          style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
               <div className="section-content ">
              <div className="our-history text-black">
                {locations.map((item, index) => (
                  <div className="row" key={index}>
                    <div className="col-12">
                      <div className="our-history-content m-b30">
                        <div className="large-title">
                          <h2 className="m-t0">{item.title}</h2>
                          <h4>{item.location}</h4>
                        </div>
                        <p>{item.description}</p>
                        {/* <NavLink
                          to={"/about-1"}
                          className="site-button-secondry btn-half"
                        >
                          <span> View All</span>
                        </NavLink> */}
                      </div>
                    </div>
                    <div className="col-12 pic-bg-border">
                      <div
                        className="our-history-pic bg-no-repeat bg-center bg-cover"
                        data-stellar-background-ratio="0.5"
                        style={{ backgroundImage: 'url(' + item.image + ')' }}
                      ></div>
                    </div>
                  </div>
                ))}
                {/* <div
                  className="text-center load-more-btn-outer"
                  style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                >
                  <button
                    id="loadMorebtn-5"
                    className="site-button-secondry btn-half"
                  >
                    <span>Load More</span>
                  </button>
                </div> */}
              </div>
            </div>
              <div className="sx-separator-outer separator-center">
                {/* <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                >
                  <h3 className="sep-line-one">About us</h3>
                </div> */}
              </div>
            </div>
            {/* TITLE END */}
            <div className="section-content ">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 m-b30">
                  {achievements1.map((item, index) => (
                    <div className="sx-box our-story text-white" key={index}>
                      <div className="mt-media our-story-info d-flex justify-content-start">
                        <div className="our-story-time">
                          <span className="date">{item.date}</span>
                          <span className="month">{item.month}</span>
                        </div>
                        <h4 className="text-uppercase our-story-year">
                          {item.year}
                        </h4>
                      </div>
                      <div className="our-story-detail">
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12">
                  {achievements2.map((item, index) => (
                    <div className="sx-box our-story text-white" key={index}>
                      <div className="mt-media our-story-info d-flex justify-content-start">
                        <div className="our-story-time">
                          <span className="date">{item.date}</span>
                          <span className="month">{item.month}</span>
                        </div>
                        <h4 className="text-uppercase our-story-year">
                          {item.year}
                        </h4>
                      </div>
                      <div className="our-story-detail">
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Achievements1
